import { render, staticRenderFns } from "./UserDrafts.vue?vue&type=template&id=365b9e3d&scoped=true&"
import script from "./UserDrafts.vue?vue&type=script&lang=js&"
export * from "./UserDrafts.vue?vue&type=script&lang=js&"
import style0 from "./UserDrafts.vue?vue&type=style&index=0&id=365b9e3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b9e3d",
  null
  
)

export default component.exports